export const translations = {
  'en-GB': {
    translation: {
      showToday: 'Show Today',
      outOfRange: 'Out of range',
      selectUpToDays: 'Select date within {maxDays} days',
      From: 'From',
      FromToDateRangeError: `To-date cannot be earlier than From-date`,
      to: 'To',
      dateFrom: 'Date From',
      loadingError: 'Loading error',
      contactAdmin:
        'Refresh the page to load the data. Contact your administrator if the problem persists.',
      searchFor: 'Search for',
      nodes: 'Node(s)',
      cancel: 'Cancel',
      back: 'Back',
      saveAndContinue: 'Save And Continue',
      yes: 'Yes',
      no: 'No',
      selectDateRange: 'Select the date range between {days} days',
      Today: 'I dag',
      Yesterday: 'I går',
      LastWeek: 'Last Week',
      ThisMonth: 'This Month',
      LastMonth: 'Last Month',
      Last3Months: 'Last 3 Months',
      Last6Months: 'Last 6 Months',
      YearToDate: 'Year To Date',
      LastYear: 'Last Year',
      datePickerErrorMsg: 'Please select the dates within {days} months range.',
      datePickerGreaterErrorMessage: 'From Date cannot be greater than To Date',
      Duration: 'Duration',
      To: 'To',
      apply: 'Apply'
    }
  }
};
